import React from "react";

const Breadcrumbs = ({ post }) => {
  return (
    <nav
      className="breadcrumbs px-4 py-2 w-full bg-white border-t border-gray-300"
      aria-label="Breadcrumb"
    >
      <ol className="flex items-center text-xs font-medium text-gray-700 space-x-2 mx-36">
        {/* Home Breadcrumb */}
        <li>
          <a
            href="/"
            className="text-gray-600 hover:text-blue-600 flex items-center"
            aria-label="Home"
          >
            <span className="sr-only">Home</span>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={1.5}
              stroke="currentColor"
              className="w-4 h-4 mr-1"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M3 10.5L12 3l9 7.5v9a1.5 1.5 0 01-1.5 1.5h-15A1.5 1.5 0 013 19.5v-9z"
              />
            </svg>
          </a>
        </li>
        <li>
          <span className="text-gray-400">/</span>
        </li>

        {/* Blog Breadcrumb */}
        <li>
          <a href="/blog/" className="text-gray-600 hover:text-blue-600">
            Blog
          </a>
        </li>
        <li>
          <span className="text-gray-400">/</span>
        </li>

        {/* Digital Freedom Breadcrumb */}
        <li>
          <a
            href="/blog/category/digital-freedom/"
            className="text-gray-600 hover:text-blue-600"
          >
            {post?.category}
          </a>
        </li>
        <li>
          <span className="text-gray-400">/</span>
        </li>

        {/* Current Page Breadcrumb */}
        <li>
          <span className="breadcrumb_last text-gray-500">{post?.title}</span>
        </li>
      </ol>
    </nav>
  );
};

export default Breadcrumbs;
